import React, { forwardRef } from 'react';
import { Helmet } from 'react-helmet-async';
// material
import { Box, BoxProps, Fade } from '@mui/material';
import { SnackbarProvider } from 'notistack';

import CInfoModal from './custom/modal/CInfoModal';
import CSnackbar from './custom/snackbar/CSnackbar';

// ----------------------------------------------------------------------

interface PageProps extends BoxProps {
  title?: string;
  needPadding?: boolean;
}

export const Page = forwardRef<HTMLDivElement, PageProps>(
  ({ children, title = '', needPadding = false, sx, ...others }, _ref) => (
    <React.Fragment>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <SnackbarProvider
        // domRoot를 body로 고정 — 화면 루트(Login Container 등)에 걸린 CSS transform/filter가
        // position:fixed의 기준(containing block)을 바꿔 스낵바가 버튼 근처에서 뜨던 문제 방지.
        domRoot={document.body}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        autoHideDuration={3000}
        TransitionComponent={Fade}
      >
        <CSnackbar />
        <Box
          {...others}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            height: '100%',
            width: '100%',
            maxWidth: '100%',
            ...(needPadding && { p: '24px' }),
            ...sx,
          }}
        >
          {children}
        </Box>
      </SnackbarProvider>
      <CInfoModal />
    </React.Fragment>
  ),
);
